import script from "./FilmCutsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FilmCutsEditor.vue?vue&type=script&setup=true&lang=js"

import "./FilmCutsEditor.vue?vue&type=style&index=0&id=6e73cdaa&lang=scss"

const __exports__ = script;

export default __exports__